import { Layout } from 'antd';
import React from 'react';

const { Content: AntdContent } = Layout;

export const Content: React.FC = ({ children }) => <AntdContent>{children}</AntdContent>;
